/**
 * 正規表現で使えるようにエスケープ処理を施す
 */
module.exports = function(str) {
    if( typeof(str) !== typeof('') ){return str;}
    return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
